module.exports = __webpack_public_path__ + "static/media/26UNRWA18.b67136cb.jpg";